import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { ChecklistService } from '../../../../services/checklist.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-checklist-configuration',
  templateUrl: './checklist-configuration.component.html',
  styleUrls: ['./checklist-configuration.component.scss'],
  providers: [MessageService],
})
export class ChecklistConfigurationComponent implements OnInit {
  public partnerId: string = '';
  public checklistItems: any = [];
  public preServiceChecklistItems: any = [];
  public mandatoryChecklistItems: any = [];
  public loading: boolean = false;
  public saving: boolean = false;
  public showChecklistItemDetail: boolean = false;
  public selectedItem: any = {};
  public columns: any = [
    {
      header: this.translate.instant('general.headers.checklist_name'),
      field: 'description',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.control_type'),
      field: 'controlType',
      type: 'controlType',
    },
    {
      header: this.translate.instant('general.headers.front_rear_check'),
      field: 'frontRearCheck',
      type: 'boolean',
    },
    {
      header: this.translate.instant('general.headers.label_colour'),
      field: 'labelColour',
      type: 'color',
    },
  ];

  constructor(
    private helpersService: HelpersService,
    private checklistService: ChecklistService,
    public messageService: MessageService,
    private translate: TranslateService,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.getChecklistItems();
  }

  getChecklistItems() {
    this.loading = true;
    this.checklistService.getPartnerChecklist(this.partnerId).subscribe(
      (checklistItems) => {
        this.preServiceChecklistItems = checklistItems.filter((x) => {
          return x.isPreServiceCheck;
        });

        this.mandatoryChecklistItems = checklistItems.filter((x) => {
          return x.mandatoryForAllServices;
        });

        this.checklistItems = checklistItems.filter((x) => {
          return !x.isPreServiceCheck && !x.mandatoryForAllServices;
        });

        this.loading = false;
      },
      (err) => {
        this.loading = false;
      },
    );
  }

  addChecklistItem() {
    this.selectedItem = {
      controlType: 'CHECKBOX',
      labelColour: '#151a2a',
    };
    this.showChecklistItemDetail = true;
  }

  editChecklistItem(item) {
    this.selectedItem = item;
    this.showChecklistItemDetail = true;
  }

  close() {
    this.showChecklistItemDetail = false;
  }
}
